<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>{{ `${organization.name}` }} - {{ $t("COMMON.LOGS") }}</h3>
    </div>
    <log-list-table :filterSubject="organization" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "organization-view-logs",

  components: { LogListTable },

  props: ["organization"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
